import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

import { useMemo, useState } from 'react';
import HTable, { IHeadTabel } from "../../Common/HTable";
import { IProfile } from "../../../Libs/Models/IProfile.model";
import { Order, stableSort, getComparator } from '../../../Libs/Extensions/Sort.extension';

const headCells: readonly IHeadTabel[] = [
  { id: "muId", label: "รหัส", align: "center", sort: true, width: 80 },
  {
    id: "username",
    label: "ชื่อ-นามสกุล",
    align: "center",
    sort: true,
    minWidth: 280,
  },
  {
    id: "email",
    label: "E-MAIL",
    align: "center",
    sort: true,
    minWidth: 280,
  },
  /* {
    id: "fullname",
    label: "ชื่อ-นามสกุล",
    align: "center",
    sort: true,
    width: 100,
  }, */
  {
    id: "year",
    label: "ปีการศึกษา",
    align: "center",
    sort: true,
    minWidth: 140,
  },
  { id: "date_created", label: "เวลาสร้างบัญชี", align: "center", sort: true, minWidth: 200 },
  { id: "date_updated", label: "เวลาอัพเดตบัญชี", align: "center", sort: true, minWidth: 200 },
  { id: "end", label: "", align: "center", sort: false, minWidth: 10 },
];

interface IProps {
  data: IProfile[];
}

export function TableStudentList(props: IProps) {
  const [order, setOrder] = useState<Order>('asc');
  const [orderBy, setOrderBy] = useState<keyof IProfile>('muId')

  //--------------------------------------------------//
  //--------------------------------------------------//
  const sortHandler = (
      event: React.MouseEvent<unknown>,
      property: keyof IProfile,
    ) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };
  
    const visibleRows = useMemo(
      () =>
        stableSort(props.data, getComparator(order, orderBy)),
      [order, orderBy, props.data],
    );
  //--------------------------------------------------//
  //--------------------------------------------------//
  return (
    <TableContainer component={Paper} elevation={0}>
      <Table size="small" sx={{ width: "100%" }} aria-label="customized table">
        <HTable 
          cells={headCells} 
          onRequestSort={sortHandler}
          order={order}
          orderBy={orderBy}/>
        <TableBody>
          {visibleRows.map((row: IProfile, index: number) => (
            <TableRow key={row.id}>
              <TableCell align="right">{row.muId}</TableCell>
              <TableCell align="left">{row.username}</TableCell>
              <TableCell align="center">{row.email}</TableCell>
              <TableCell align="center">{row.year}</TableCell>
              <TableCell align="center">{new Date(row.date_created).toLocaleString()}</TableCell>
              <TableCell align="center">{new Date(row.date_updated).toLocaleString()}</TableCell>
              <TableCell></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
